module.exports = __webpack_public_path__ + "img/adicionar-usuario.7b6762f2.png";